import {
    Box,
    Divider,
    List,
    ListItem,
    ListItemText,
    Stack,
    Typography,
} from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import AuthContainer from "../../components/containers/AuthContainer";

const PrivacyPolicy = () => {
    return (
        <AuthContainer>
            <Typography
                color={"primary.main"}
                fontSize={"1.8rem"}
                fontWeight={700}
                textAlign={"center"}
                mb={2}
            >
                Privacy Policy
            </Typography>



            <Box sx={{ maxHeight: "400px", overflowY: "auto", pr: 1 }}>
                <Stack spacing={2}>
                    <Box>
                        <Typography variant="h6" fontWeight={600} mb={1}>
                            1. Information We Collect
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            We collect information you provide directly to us, such as when you create an account,
                            use our services, or contact us for support.
                        </Typography>
                    </Box>

                    <Divider />

                    <Box>
                        <Typography variant="h6" fontWeight={600} mb={1}>
                            2. How We Use Your Information
                        </Typography>
                        <List dense>
                            <ListItem sx={{ py: 0 }}>
                                <ListItemText
                                    primary="• Provide and maintain our services"
                                    primaryTypographyProps={{ variant: "body2", color: "text.secondary" }}
                                />
                            </ListItem>
                            <ListItem sx={{ py: 0 }}>
                                <ListItemText
                                    primary="• Process transactions and send notifications"
                                    primaryTypographyProps={{ variant: "body2", color: "text.secondary" }}
                                />
                            </ListItem>
                            <ListItem sx={{ py: 0 }}>
                                <ListItemText
                                    primary="• Improve our services and user experience"
                                    primaryTypographyProps={{ variant: "body2", color: "text.secondary" }}
                                />
                            </ListItem>
                        </List>
                    </Box>

                    <Divider />

                    <Box>
                        <Typography variant="h6" fontWeight={600} mb={1}>
                            3. Information Sharing
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            We do not sell, trade, or otherwise transfer your personal information to third parties
                            without your consent, except as described in this policy.
                        </Typography>
                    </Box>

                    <Divider />

                    <Box>
                        <Typography variant="h6" fontWeight={600} mb={1}>
                            4. Data Security
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            We implement appropriate security measures to protect your personal information against
                            unauthorized access, alteration, disclosure, or destruction.
                        </Typography>
                    </Box>

                    <Divider />

                    <Box>
                        <Typography variant="h6" fontWeight={600} mb={1}>
                            5. Contact Us
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            If you have any questions about this Privacy Policy, please contact us at support@residentialjobs.com
                        </Typography>
                    </Box>
                </Stack>
            </Box>

            <Stack
                mt={3}
                direction={"row"}
                alignItems={"center"}
                justifyContent={"center"}
                gap={2}
            >
                <Link className="forgot-link" to={"/login"}>
                    Back to Login
                </Link>
            </Stack>
        </AuthContainer>
    );
};

export default PrivacyPolicy; 